// src/pages/SearchBar.jsx
import React, { useContext } from 'react';
import { ShopContext } from "../context/ShopContext.jsx";
import { Box, TextField, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

const SearchBar = () => {
  const { search, setSearch, showSearch, setShowSearch } = useContext(ShopContext);

  if (!showSearch) return null;

  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        py: 1,
        backgroundColor: 'background.paper',
        boxShadow: 1,
        borderRadius: 1,
        mb: 2,
      }}
    >
      {/* Center Box for TextField + Search Icon */}
      <Box
        sx={{
          width: { xs: '90%', lg: '50%' },
          mx: 'auto',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search products..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': { borderColor: 'grey.400' },
              '&:hover fieldset': { borderColor: 'black' },
              '&.Mui-focused fieldset': { borderColor: 'black' },
            },
          }}
        />
        <SearchIcon sx={{ ml: 2, color: 'grey.500' }} />
      </Box>

      {/* Close Icon at the Far Right */}
      <IconButton
        onClick={() => setShowSearch(false)}
        sx={{
          position: 'absolute',
          right: 8,
          top: '50%',
          transform: 'translateY(-50%)',
        }}
      >
        <CloseIcon sx={{ color: 'grey.500', display: {xs: 'none', lg: 'block'} }} />
      </IconButton>
    </Box>
  );
};

export default SearchBar;
